/* Moments Etched Master Apparel Registry v3.4.0 */
window.MEApparelRegistry = {
  "1000": {
    "name": "Unisex Max Tee",
    "family": "family-1000",
    "template": "tee-standard",
    "placementSet": "tee",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ],
    "variantMode": false
  },
  "1001": {
    "name": "Premium Unisex Tee",
    "family": "family-1001",
    "template": "tee-standard",
    "placementSet": "tee",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ],
    "variantMode": false
  },
  "1003": {
    "name": "Unisex V-Neck Tee",
    "family": "family-1003",
    "template": "supplier-photo",
    "placementSet": "tee",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ],
    "variantMode": false
  },
  "1004": {
    "name": "Premium Long Sleeve Tee",
    "family": "family-1004",
    "template": "supplier-photo",
    "placementSet": "long-sleeve",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ],
    "variantMode": false
  },
  "1005": {
    "name": "Women's Fitted Tee",
    "family": "family-1005",
    "template": "supplier-photo",
    "placementSet": "tee",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ],
    "variantMode": false
  },
  "1007": {
    "name": "Youth Premium Tee",
    "family": "family-1007",
    "template": "tee-youth",
    "placementSet": "youth-tee",
    "sizes": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ],
    "variantMode": false
  },
  "2011": {
    "name": "Superior Mid Weight Hoodie",
    "family": "family-2011",
    "template": "supplier-photo",
    "placementSet": "hoodie",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ],
    "variantMode": true,
    "colors": [
      "White",
      "Royal Blue",
      "Black",
      "Red",
      "Charcoal Heather",
      "Navy",
      "Dust",
      "Sports Grey"
    ]
  },
  "2013": {
    "name": "Superior Mid Weight Crew Sweatshirt",
    "family": "family-2013",
    "template": "supplier-photo",
    "placementSet": "crewneck",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ],
    "variantMode": true,
    "colors": [
      "Black",
      "White",
      "Dust",
      "Royal Blue",
      "Red",
      "Navy",
      "Sports Grey",
      "Charcoal Heather"
    ]
  },
  "11001": {
    "name": "Premium Pullover Hoodie",
    "family": "family-11001",
    "template": "supplier-photo",
    "placementSet": "hoodie",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ],
    "variantMode": true,
    "colors": [
      "Black",
      "Denim"
    ]
  },
  "11005": {
    "name": "Premium Unisex Hoodie",
    "family": "family-11005",
    "template": "supplier-photo",
    "placementSet": "hoodie",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ],
    "variantMode": true,
    "colors": [
      "Salt & Pepper",
      "Black"
    ]
  },
  "1122": {
    "name": "Women's Crop Hoodie",
    "family": "family-1122",
    "template": "supplier-photo",
    "placementSet": "crop-hoodie",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ],
    "variantMode": true,
    "colors": [
      "Red",
      "Dust",
      "Black",
      "White"
    ]
  },
  "1133": {
    "name": "Crop Top",
    "family": "family-1133",
    "template": "supplier-photo",
    "placementSet": "crop-tee",
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ],
    "variantMode": true,
    "colors": [
      "Sports Grey",
      "Baby Pink",
      "Dust",
      "Powder Blue",
      "White",
      "Black"
    ]
  }
};

(function(){
  'use strict';
  function numberFromTitle(value){
    const match=String(value||'').trim().match(/^(\d{4,5})\b/);
    return match ? match[1] : '';
  }
  function normalize(value){
    return String(value||'').trim().toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  }
  function readProduct(){
    const node=document.querySelector('[data-me-initial-product-json]');
    if(!node) return null;
    try{return JSON.parse(node.textContent);}catch(e){return null;}
  }
  function optionIndex(product,names){
    const options=Array.isArray(product?.options)?product.options:[];
    return options.findIndex(o=>names.includes(String(typeof o==='string'?o:o?.name||'').trim().toLowerCase()));
  }
  function variants(product){return Array.isArray(product?.variants)?product.variants:[];}
  function variantOptions(v){return Array.isArray(v?.options)?v.options:[v?.option1,v?.option2,v?.option3];}
  function uniqueVariantColors(product){
    const idx=optionIndex(product,['color','colour','shirt color','garment color']);
    if(idx<0) return [];
    const found=[]; const seen=new Set();
    variants(product).forEach(v=>{const value=String(variantOptions(v)[idx]||'').trim(); const key=normalize(value); if(value&&!seen.has(key)){seen.add(key);found.push(value);}});
    return found;
  }
  const product=readProduct();
  const productNumber=numberFromTitle(product?.title||document.title);
  const config=window.MEApparelRegistry?.[productNumber]||null;
  window.MEApparelEngine={
    version:'3.4.0', productNumber, config, normalizeColor:normalize, numberFromTitle, uniqueVariantColors,
    getConfig(number){return window.MEApparelRegistry?.[String(number)]||null;}
  };
  if(!config) return;
  const sizePicker=document.querySelector('[data-me-size-picker]');
  if(sizePicker && config.sizes?.length && !sizePicker.dataset.meFallbackSizes){sizePicker.dataset.meFallbackSizes=config.sizes.join('|');}
  if(sizePicker) sizePicker.dataset.meProductNumber=productNumber;
  const colorBlock=document.querySelector('[data-me-designer-colors]');
  if(colorBlock){colorBlock.dataset.meFamily=config.family||`family-${productNumber}`; colorBlock.dataset.meProductNumber=productNumber; colorBlock.dataset.meVariantMode=config.variantMode?'true':'false';}
  window.MECatalog=window.MECatalog||{families:{}}; window.MECatalog.families=window.MECatalog.families||{};
  const key=config.family||`family-${productNumber}`;
  const existing=window.MECatalog.families[key]||{};
  let colors=existing.colors||[];
  if(!colors.length){
    const names=config.colors?.length?config.colors:uniqueVariantColors(product);
    const handle=String(product?.handle||colorBlock?.dataset.meCurrentHandle||'');
    colors=names.map(name=>({name,handle,variantMode:true}));
  }
  window.MECatalog.families[key]={...existing,label:existing.label||config.name,template:config.template,placementSet:config.placementSet,variantMode:Boolean(config.variantMode),sizes:config.sizes||[],colors};
})();
